import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServiceProvider } from '../../../providers/ServiceProvider';
import * as HighCharts from 'highcharts';

/*
  Generated class for the ODataDetails page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-ODataDetails',
    templateUrl: 'ODataDetails.html'
})
export class ODataDetailsPage {
    OData: any = {};
    Datas: any = [];
    tcoidForTajhizat: any = 0;
    DataForReport: any = 'none';
    constructor(public navCtrl: NavController, public navParams: NavParams, public serviceProvider: ServiceProvider) {
        this.OData = this.navParams.get("data");
        this.tcoidForTajhizat = this.navParams.get('TajhizatCoid');
    }
    ionViewDidLoad() {
        this.LoadData();
    }
    LoadData() {
        if (this.OData.Id >= 33 && this.OData.Id <= 37) {
            let idFilter: any = 0;
            switch (this.OData.Id) {
                case 33: {
                    idFilter = 10;
                    break;
                }
                case 34: {
                    idFilter = 19;
                    break;
                }
                case 35: {
                    idFilter = 31;
                    break;
                }
                case 36: {
                    idFilter = 15;
                    break;
                }
                case 37: {
                    idFilter = 59;
                    break;
                }
                default:
            }
            this.Datas.splice(0, this.Datas.length);
            this.serviceProvider.Get("/ISPA_VFToken?codId=" + this.tcoidForTajhizat, true).then((result) => {
                let datas: any = result;
                datas.forEach((value, item) => {
                    if (idFilter == value.cdValue1) {
                        let icon = this.getIcon(value);
                        value.LeftIcon = icon;
                        this.Datas.push(value);
                    }
                });
            });

            //Report
            //this.DataForReport.splice(0, this.DataForReport.length);
            this.serviceProvider.Get("/ISPA_VFToken?codId=" + this.OData.tCustomerODataId, true).then((result: any) => {
                let Data: any = result;
                console.log(Data);
                let xAxis: any = [];
                let series: any = [];
                let SeriesName: string;
                let XAxisName: string;
                if (Data.length != 0) {
                    for (var i = 0; i < Data.length; i++) {
                        var addedBefore = false;
                        xAxis.push(Data[i].cdValue1_txt);
                        for (var j = 0; j < series.length; j++) {
                            if (series[j].name == Data[i].cdValue2_txt) {
                                addedBefore = true;
                                series[j].data.push(parseFloat(Data[i].DetailedForm[0].cddValue))
                            }
                        }
                        if (!addedBefore) {
                            series.push({
                                name: Data[i].cdValue2_txt,
                                data: [parseFloat(Data[i].DetailedForm[0].cddValue)]
                            });
                        }
                    }
                    console.log(series);
                    this.DataForReport = 'block';
                    //Data.forEach((value, index) => {
                    //    xAxis.push(value.cdValue1_txt);
                    //    series.push(parseFloat(value.DetailedForm[0].cddValue));
                    //    XAxisName = value.DetailedForm[0].oddLabel;
                    //    SeriesName = value.cdValue2_txt;
                    //});
                    var myChart = HighCharts.chart('ChartContainer', {
                        chart: {
                            type: 'line'
                        },
                        title: {
                            text: ''
                        },
                        xAxis: {
                            categories: xAxis
                        },
                        yAxis: {
                            min: 0,
                            title: {
                                text: SeriesName
                            }
                        },
                        series: series
                        //    [{
                        //    name: SeriesName,
                        //    data: series,
                        //    //color: chart.odColor
                        //}]
                    });
                }
            });
        }
        else {
            this.Datas.splice(0, this.Datas.length);
            this.serviceProvider.Get("/ISPA_VFToken?codId=" + this.OData.tCustomerODataId, true).then((result) => {
                let datas: any = result;
                datas.forEach((value, item) => {
                    let icon = this.getIcon(value);
                    value.LeftIcon = icon;
                    this.Datas.push(value);
                });
            });
        }
        
    }
    getIcon(value) {
        let icon = {
            havIcon: false,
            color: '#336699',
            borderRadius: '0px'
        };
        if (value.cdValue1 == '8') {
            icon.color = '#d36ad3';
            icon.havIcon = true;
            icon.borderRadius = this.getBorderRadius(value.DetailedForm);
        }
        if (value.cdValue1 == '10') {
            icon.color = '#76be6a';
            icon.havIcon = true;
            icon.borderRadius = this.getBorderRadius(value.DetailedForm);
        }
        if (value.cdValue1 == '19') {
            icon.color = '#e2d167';
            icon.havIcon = true;
            icon.borderRadius = this.getBorderRadius(value.DetailedForm);
        }
        if (value.cdValue1 == '31') {
            icon.color = '#f37578';
            icon.havIcon = true;
            icon.borderRadius = this.getBorderRadius(value.DetailedForm);
        }
        if (value.cdValue1 == '15') {
            icon.color = '#86bbdb';
            icon.havIcon = true;
            icon.borderRadius = this.getBorderRadius(value.DetailedForm);
        }
        if (value.cdValue1 == '59') {
            icon.color = '#afafaf';
            icon.havIcon = true;
            icon.borderRadius = this.getBorderRadius(value.DetailedForm);
        }
        return icon;
    }

    getBorderRadius(DetailedForms) {
        for (var i = 0; i < DetailedForms.length; i++) {
            if (DetailedForms[i].tODataDetailId == 10092) {
                if (DetailedForms[i].cddValue == 46) {
                    return '50%';
                }
                break;
            }
        }
        return '0px';
    }
}



// WEBPACK FOOTER //
// ./src/pages/atlas/ODataDetails/ODataDetails.ts